// extracted by mini-css-extract-plugin
module.exports = {"createMerchant":"MerchantForm_createMerchant__FRcye","createMerchantForm":"MerchantForm_createMerchantForm__LNY6-","addCategory":"MerchantForm_addCategory__2Ce14"};